<ng-container *ngIf="articleRevenueState$ | async as state">
    <h1 mat-dialog-title class="active">
        {{"app.dialog.add-article-revenue.title.header" | translate: { article: article.name } }}
    </h1>
    <div mat-dialog-content>
        <mat-generic-input [fields]="layout.fields" [(inputFormGroup)]="formGroup"></mat-generic-input>
    </div>

    <div mat-dialog-actions>
        <button mat-stroked-button mat-dialog-close (click)="closeDialog(false)">{{ "app.button.cancel.label" | translate }}</button>
        <button [disabled]="!(dialogFieldsValid$ | async)" mat-flat-button color="primary" (click)="onSave()">{{ "app.button.save.label" | translate }}</button>
    </div>
</ng-container>
